import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from '@mystudioclass/auth';
import { AuthProvider as AppAuthProvider } from './context/AuthContext';
import ApiTokenProvider from './components/AuthTokenProvider';
import App from './App';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <AuthProvider>
    <ApiTokenProvider>
      <AppAuthProvider>
        <QueryClientProvider client={queryClient}>
          <App />
          <Toaster position="top-right" />
        </QueryClientProvider>
      </AppAuthProvider>
    </ApiTokenProvider>
  </AuthProvider>
);
